import Image from 'next/image'
import Link from '@/components/ui/Link'
import ImagePattern from '../ImagePattern'
import { getReadableImageUrl } from '@/lib/directus'
import { getGalleryPatientUrl } from '@/lib/gallery'
import HomeTopForm from '@/components/ContactForm/HomeTopForm'

interface ProcedureSectionProps {
	data?: any
}
export const fields = ['*'] as const

export default function ProcedureSection({ data }: ProcedureSectionProps) {
	return (
		<>
			<section id='ProcedureSection' className='py-12 bg-[#b1a3a426]'>
				<div className='container'>
					<div className='grid md:grid-cols-3 grid-cols-1 gap-6'>
						{data.patients.map(
							(patient, index: number) =>
								patient.photos &&
								patient.photos.length > 0 && (
									<Link
										key={index}
										href={getGalleryPatientUrl(data.procedureSlug, patient.id)}
										className='img_box block transition-opacity hover:opacity-90 m-2'
									>
										<div className='relative flex items-center justify-center md:h-full'>
											{patient.photos[0]?.site_content_collections_id
												?.collection && (
												<div className='relative grid grid-cols-2 w-full gap-[5px] image-container'>
													{patient.photos[0].site_content_collections_id.collection.map(
														(collectionItem, idx) => {
															const imageData =
																collectionItem.item?.image_file?.image
															return (
																<div key={idx} className='relative'>
																	<div className='relative h-auto'>
																		{imageData && (
																			<Image
																				src={getReadableImageUrl(
																					imageData.id,
																					imageData.filename_download
																				)}
																				alt={
																					collectionItem.item.alt ||
																					'Before & After Procedure'
																				}
																				width={400}
																				height={600}
																				className='w-full h-auto'
																				quality={95}
																				priority={true}
																			/>
																		)}
																	</div>
																	<div
																		className={`absolute bottom-2 ${
																			idx === 0 ? 'left-2' : 'right-2'
																		} text-xs tracking-[0.2em] font-bold text-white`}
																	>
																		{idx === 0 ? 'BEFORE' : 'AFTER'}
																	</div>
																</div>
															)
														}
													)}
												</div>
											)}
											{(!patient.photos[0]?.site_content_collections_id
												?.collection ||
												patient.photos[0].site_content_collections_id.collection
													.length === 0) && (
												<ImagePattern className='text-sm' />
											)}
										</div>
										<div className='bg-black py-3 text-center md:hidden'>
											<span className='text-white font-medium'>
												VIEW PATIENT DETAIL
											</span>
										</div>
									</Link>
								)
						)}
					</div>
				</div>
			</section>
			<HomeTopForm />
		</>
	)
}
